<template>
  <div class="home">
    <div @mouseover="modalFn(2,'big')">
      <div
        :class="['background-img', bannerInfo.classify != '1' ? 'curs' : '']"
        :style="{ backgroundImage: 'url(' + bannerInfo.pic + ')' }"
        @click="bannerClick"
      >
        <!-- 导航栏 style="background: rgba(0, 0, 0, 0.2)" -->
        <div class="w navi">
          <div class="flex logo_top">
            <img
              style="height: 48px"
              :src="imgPrefix + findTopBar.logoWhite"
              alt=""
            />
            <div class="flex top_r">
              <!-- <div style="cursor: pointer;" @click="toSchool">湖北民族大学官网</div> -->
              <template v-if="userId">
                <!-- <div class="line_ver"></div> -->
                <a-dropdown>
                  <a
                    class="ant-dropdown-link"
                    style="color: #ffffff"
                    @click="(e) => e.preventDefault()"
                  >
                    {{ supUserName }}<a-icon type="down" />
                  </a>
                  <a-menu slot="overlay">
                    <a-menu-item>
                      <a href="javascript:;" @click.stop="logout">退出登录</a>
                    </a-menu-item>
                  </a-menu>
                </a-dropdown>
              </template>
              <!-- <div v-else @click.stop="loginFn">登录</div> -->
            </div>
          </div>
          <div class="flex" @mouseover="modalFn(2,'big')">
            <div
                :class="item.link == '/' ? 'line_class navi_box' : 'navi_box'"
                v-for="(item, index) in newNaviArr"
                :key="index"
                @click.stop="changeUrl(item.link, item)"
                @mouseover.stop="handleMouseOver(item.link, item)"
              >
              <div class="flex">
                <img :src="item.pictrue" alt="" style="margin-right: 6px;">
                <div style="font-size: 18px;">{{ item.name }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="line"></div>
        <div
          class="w flex"
          style="justify-content: space-between; margin-top: 72px"
        >
          <div style="width: 66%">
            <div class="ban_title">
              <div class="sloganColor">{{ findTopBar.sysName }}</div>
              <div class="sloganColor">{{findTopBar.slogan}}</div>
            </div>
            <!-- 搜索栏 -->
            <div class="w search_class">
              <div class="serach_box">
                <input
                  class="serach_ipt"
                  type="text"
                  v-model.trim="keyWord"
                  @click.stop="onClick"
                  @keyup.enter="onSearch"
                  placeholder="请输入您要查询的服务..."
                />
                <div @click.stop="onSearch" class="serach_bon">搜索</div>
              </div>
              <div class="flex search_ul" style="margin-top: 16px">
                <span>最常搜索：</span>
                <div class="search_tag" v-for="item in history" :key="item">
                  <span>{{ item }}</span>
                </div>
              </div>
            </div>
          </div>
          <!-- 顶部办事栏 -->
          <!-- <div class="common_box">
            <div class="common_box_top flex">
              <div
                :class="[
                  'common_box_title',
                  index == commonIdx ? 'common_box_title_cls' : '',
                ]"
                v-for="(item, index) in commonTitle"
                :key="index"
                @click.stop="getFindTopBanner(index + 1,item.id)"
              >
                {{ item.name }}
              </div>
            </div>
            <div class="flex common_ul">
              <li
                class="common_li"
                v-for="(item, index) in commonList"
                :key="index"
                @click.stop="topWork(item)"
              >
                {{ item.name }}
              </li>
            </div>
          </div> -->
        </div>
  
        <!-- 指示栏 -->
        <div class="tips">
          <a
            href="javascript:;"
            v-for="item in sidebarList"
            :key="item.id"
            @click.stop="goToOrder(item)"
          >
            <template v-if="item.classify == 1 || item.classify == 2">
              <img :src="imgPrefix + item.icon" alt="" />
              <div>{{ item.name }}</div>
            </template>
            <template v-else>
              <a-popover placement="left">
                <template slot="content">
                  <img
                    v-if="item.classify == 3"
                    :src="imgPrefix + item.content"
                    alt=""
                  />
                  <div v-else>{{ item.content }}</div>
                </template>
                <img :src="imgPrefix + item.icon" alt="" />
                <div>{{ item.name }}</div>
              </a-popover>
            </template>
          </a>
        </div>
      </div>
  
      <!-- 模块内容 :class="item.code == 2 ? 'feature_bg':''" -->
      <div v-for="(item,idx) in homeModule" :key="item.code" :style="idx == 0?'margin-top: 109px':'margin-top: 56px'">
        <div
          class="flex w"
          v-if="item.status == 1&&item.code != 3"
          style="justify-content: space-between"
        >
          <div class="title">
            {{ item.name }}
            <span v-if="item.code == 1" class="work_service_time"
              >截止 {{ currentTime }} 共上线
              <span>{{ serviceTotal }}</span> 项服务</span
            >
          </div>
          <div v-if="item.code != 3&&item.code != 4" class="check_more flex" @click="toNavi(item.code)">
            <div>查看更多</div>
            <img src="../assets/icon/icon_arrow_right.png" alt="">
          </div>
        </div>
  
        <!-- 办事服务 -->
        <div v-if="item.code == 1 && item.status == 1" class="w work_service">
          <div class="flex work_navi">
            <div
              v-for="(item, index) in workNaviData"
              :key="index"
              :class="[
                'work_box',
                index == 0 ? '' : 'work_cls',
                workIndex == index ? 'click_sty' : '',
              ]"
              @click="getFindService(index + 1, item.id)"
            >
              <div>{{ item.targetName }}办事</div>
            </div>
          </div>
  
          <div class="work_lattice flex">
            <div
              class="lat_out flex"
              v-for="(item, index) in workData"
              :key="index"
            >
              <img
                v-if="item.icon"
                :src="imgPrefix + item.icon"
                style="height: 80px"
                alt=""
              />
              <img
                v-else
                src="../assets/index/icon-default.png"
                style="height: 80px"
                alt=""
              />
              <div class="lat-r">
                <div class="lat_tit flex">
                  {{ item.serviceManageName }}
                  <span
                    :class="[
                      'work_tag',
                      item.priority == 1
                        ? 'work_tag_bg3'
                        : item.priority == 2
                        ? 'work_tag_bg2'
                        : '',
                    ]"
                    v-if="item.priority != 0"
                    >{{
                      item.priority == 1
                        ? "上新"
                        : item.priority == 2
                        ? "荐":''
                    }}</span >
                    <div v-if="item.priority == 3">
                      <img src="../assets/icon/icon_top.png" alt="">
                    </div>
                    <!-- &nbsp;<span v-if="item.isLimitTime" class="work_tag work_tag_bg1">限时</span> -->
                </div>
                <div class="lat_con flex">
                  <!--  class="lat_con_cls" -->
                  <div class="text_top" style="max-width: 82px">
                   {{ item.way==1?'线上办':item.way==0?'线上和线下':item.way==2?'线下办':'--' }}
                  </div>
                  <a-divider type="vertical" />
                  <!-- 0:不限制;1:PC端;2:移动端 -->
                  <div class="text_top">{{ item.terminal==0?'终端不限制':item.terminal==1?'PC端办理':item.terminal==2?'移动端办理':'' }}</div>
                </div>
                <!-- <div class="flex lat_bom">
                  <div class="flex lat_hot">
                    <img
                      class="pr_11"
                      src="../assets/index/icon-hot.png"
                      alt=""
                    />
                    <div>热度：{{ item.heatValue }}</div>
                  </div>
                  <div class="flex">
                    <img
                      class="pr_11"
                      src="../assets/index/icon-collection.png"
                      alt=""
                    />
                    <div>收藏：{{ item.collectValue }}</div>
                  </div>
                </div> -->
              </div>
              <!-- idx == 2 ? '' : 'hover_box_fal' -->
              <div class="hover_cls">
                <!-- <a
                  href="javascript:;"
                  :class="['hover_box']"
                  @click="gotoWork(0, item)"
                >
                  <span>添加收藏</span>
                </a>
                <a-divider style="opacity: 0.6; top: 0" type="vertical" /> -->
                <a
                  href="javascript:;"
                  :class="['hover_box']"
                  @click="gotoWork(1, item)"
                >
                  <span>服务指南</span>
                </a>
                <a-divider
                  v-if="item.isApply"
                  style="opacity: 0.6; top: 0"
                  type="vertical"
                />
                <a
                  v-if="item.isApply"
                  href="javascript:;"
                  :class="['hover_box']"
                  @click="gotoWork(2, item)"
                >
                  <span>我要办理</span>
                </a>
              </div>
            </div>
          </div>
        </div>
  
        <!-- 特色专栏 -->
        <div v-if="item.code == 2 && item.status == 1" class="feature">
          <div class="w">
            <a-carousel style="margin: -1rem">
              <div
                class="swiper_box"
                v-for="(el, index) in featureData"
                :key="index"
              >
                <div
                  class="box_shadow"
                  v-for="item in el"
                  :key="item.id"
                  @click="gotoThemeDetails(item)"
                >
                  <div class="sip_hover">
                    <img :src="imgPrefix + item.card" alt="图片" />
                    <div class="swiper_con">
                      <div class="swiper_tit">{{ item.name }}</div>
                      <div class="swiper_clamp">{{ item.introduction }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </a-carousel>
          </div>
        </div>
  
        <!-- 服务统计 -->
        <div v-if="item.code == 3 && item.status == 1" class="service_data w">
          <div class="service_data_bner">
            <div class="w flex data_box">
              <div
                class="sev_data_box"
                v-for="(item, index) in serviceData"
                :key="index"
              >
                <div class="sev_data_cls">{{ item.number }}</div>
                <div>{{ item.name }}</div>
              </div>
            </div>
          </div>
        </div>
  
        <!-- 快捷通道 -->
        <div v-if="item.code == 4 && item.status == 1" class="w shortcut">
          <div class="shortcut_big">
            <div
              class="shortcut_box"
              v-for="(item, index) in shortcutData"
              :key="index"
              @click="gotoShortcut(item.link)"
            >
              <div class="blue_line"></div>
              <img :src="imgPrefix + item.icon" alt="" />
              <div class="name">{{ item.name }}</div>
            </div>
          </div>
        </div>
  
        <!-- 通知公告 -->
        <div v-if="item.code == 5 && item.status == 1" class="w notice">
          <div class="notice_ul" v-if="noticeData.length>0">
            <div class="notice_li" v-for="(item,index) in noticeData" :key="index" @click="gotoNoticeDetails(item)">
              <div class="notice_time">
                <div class="day_time">{{item.time.substring(8,10)}}</div>
                <div class="year_time">{{item.time.substring(0,7)}}</div>
              </div>
              <div class="notice_title">{{ item.title }}</div>
            </div>
          </div>
          <!-- <div
            class="notice_big flex"
            :style="
              noticeData.length > 2 ? 'justify-content: space-between;' : ''
            "
          >
            <div
              class="notice_box"
              v-for="(item, index) in noticeData"
              :style="noticeData.length > 2 ? '' : 'margin-right:20px'"
              :key="index"
              @click="gotoNoticeDetails(item)"
            >
              <h2 class="notice_title ellipsis">{{ item.title }}</h2>
              <div class="con ellipsis" v-html="item.content"></div>
              <div class="flex bom_cls clearfix">
                <div class="bom">
                  <img src="../assets/index/icon-time-gary-outline.png" alt="" />
                  <span class="dept_css" style="max-width: 100px">{{
                    item.time
                  }}</span>
                </div>
                <a-divider type="vertical" style="margin: 0 1.375rem" />
                <div class="bom">
                  <img
                    src="../assets/index/icon-publisher-gary-outline.png"
                    alt=""
                  />
                  <span class="dept_css">{{ item.departmentName }}</span>
                </div>
              </div>
            </div>
          </div> -->
        </div>

        <!-- 服务地图 -->
        <div class="w map_box" v-if="item.code == 6 && mapList.length > 0">
          <div class="flex">
            <div class="map-img">
              <img :src="mapList[mapIdx].map?imgPrefix + mapList[mapIdx].map:noMapImg" alt="">
            </div>
            <div class="map_ul">
              <div :class="['map_li',mapList.length==1?'map_':'']" v-for="(item,idx) in mapList" :key="idx" @mouseover="handleHover(idx)" @click="toMap(item.addressLink)">
                <div class="flex">
                  <img src="../assets/icon/icon-positioning.png" alt="">
                  <div class="dept_name">{{item.deptName}}</div>
                </div>
                <div class="map_info">
                  <div>{{item.address}}</div>
                  <div>{{item.workTime}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
  
      <!-- 页脚 -->
      <Footer />
    </div>
    <!-- 部门弹窗 -->
     <div class="w" @mouseover="modalFn(1,'mask')" @mouseleave="modalFn(2,'big')">
       <Department class="dept_modal" v-if="ifShowDept" :naviArr="naviArr" />
     </div>
  </div>
</template>

<script>
import "swiper/dist/js/swiper";
import "swiper/dist/css/swiper.css";
import Swiper from "swiper";
import Footer from "../components/Footer.vue";
import Department from "../components/Department.vue";

import imgPrefix from "../../utils/imgPrefix";
import { format } from "../../utils/utils";
import {
  findTopBarApi,
  findHoverApi,
  findTopBannerApi,
  findServiceApi,
  findNavApi,
  findHomeModuleApi,
  findFeatureColumnByListApi,
  findChannelApi,
  findNoticeApi,
  findServiceSummaryApi,
  findTargetsApi,
  logout,
  usageLogsApi,
  findServiceMapApi,
  findUnionByKeywordApi
} from "../api/index";

// 将一维数组中以四个元素为一个单位提取到一个数组中，建立一个二维数组
Array.prototype.chunk = function (len) {
  var len = parseInt(len);
  if (len <= 1 || this.length < len) return this;
  var groups = [],
    loop = Math.ceil(this.length / len);
  for (var i = 0; i < loop; i++)
    groups.push(this.slice(len * i, len * (i + 1)));
  return groups;
};
export default {
  data() {
    return {
      imgPrefix,
      bannerInfo: {},
      findTopBar: {},
      homeModule: {},
      sidebarList: [],
      naviArr: [],
      newNaviArr: [],
      commonTitle: [{id:'student',name:"学生常用"}, {id:'teacher',name:"教师常用"}],
      commonIdx: 0,
      commonList: [],
      history: ["一卡通", "请假", "奖助学金"],
      dataLet: 2,
      featureData: [[]],
      workIndex: 0,
      workNaviData: [],
      workData: [],
      workHover: ["添加收藏", "服务指南", "我要办理"],
      serviceData: [
        { name: "当前进驻事项", number: "0" },
        { name: "可在线办理事项", number: "0" },
        { name: "进驻服务部门", number: "0" },
        { name: "在线办理覆盖率", number: "0%" },
        // { name: "事项平均分", number: "3.5" },
      ],
      shortcutData: [],
      noticeData: [],
      currentTime: "",
      serviceTotal: 0,
      keyWord: "",
      userId: "",
      supUserName: "",
      ifShowDept: false,
      naviId:'',
      mapList: [],
      mapIdx: 0,
      noMapImg: require('../assets/no-date-red.png'),
      type: '',
    };
  },
  components: { Footer,Department },
  computed: {},
  watch: {},
  created() {
    // 获取登录后的userId
    this.userId = sessionStorage.getItem("userId");
    // 获取登录信息
    let info = sessionStorage.getItem("ly-portal-affairs-ui-userLogin");
    if (sessionStorage.getItem("ly-portal-affairs-ui-userLogin")) {
      info = JSON.parse(info);
      // console.log(info);
      this.supUserName = info?.userName;
    }
    // 获取当前时间
    let time = new Date();
    this.currentTime = format(time, "yyyy-MM-dd");
    sessionStorage.setItem("naviId", 0);
    // 获取顶部栏基本信息
    findTopBarApi().then((res) => {
      // console.log(res);
      this.findTopBar = res;
      document.title = res.sysName;
      // 改变主题颜色
      const bodyStyle = document.getElementsByTagName("body")[0].style;
      bodyStyle.setProperty("--themeColor", res.topicColor);
      bodyStyle.setProperty("--themeColor1", this.hexToRgba(res.topicColor, 0.1));
      bodyStyle.setProperty("--themeColor6", this.hexToRgba(res.topicColor, 0.6));
      bodyStyle.setProperty("--themeSloganColor", res.sloganColor);
      // 改变网站图标
      var link =
        document.querySelector("link[rel*='icon']") ||
        document.createElement("link");
      link.type = "image/x-icon";
      link.rel = "shortcut icon";
      link.href = this.imgPrefix + res.webInco;
      document.getElementsByTagName("head")[0].appendChild(link);
      sessionStorage.setItem("findTopBar", JSON.stringify(res));
    });
    // 获取顶部导航
    findNavApi().then((res) => {
      // console.log(res);
      this.naviArr = res;
      this.newNaviArr = res.filter((item) => {
        if(item.link == '/'){
          // item.pictrue = require('../assets/icon/header/icon_index_blue.png')
          item.pictrue = require('../assets/icon/header/icon_index_red.svg')
        }else if(item.link == '/theme'){
          item.pictrue = require('../assets/icon/header/icon_theme_white.png')
        }else if(item.link == '/serviceHall'){
          item.pictrue = require('../assets/icon/header/icon_service_white.png')
        }else if(item.link == '/detailedList'){
          item.pictrue = require('../assets/icon/header/icon_list_white.png')
        }
        return item.status == "1";
      });
      res.forEach((item) => {
        if (item.link == "/") {
          this.bannerInfo = item.navBannerVoList[0];
          this.bannerInfo.pic = this.imgPrefix + this.bannerInfo.pic;
        }
      });
      sessionStorage.setItem("naviArr", JSON.stringify(res));
    });
    // 获取顶部栏悬浮按钮信息
    findHoverApi().then((res) => {
      // console.log(res);
      this.sidebarList = res;
    });
    // 服务统计
    findServiceSummaryApi().then((res) => {
      this.serviceData[0].number = res.allServiceNumber;
      this.serviceData[1].number = res.availableServiceNumber;
      this.serviceData[2].number = res.serviceDeptNumber;
      this.serviceData[3].number =
        (res.availableServiceRate * 100).toFixed(2) + "%";
    });

    // 获取模块标题和状态
    findHomeModuleApi().then((res) => {
      // console.log(res);
      this.homeModule = res;
      res.forEach((item) => {
        if (item.code == 1) {
          if (item.status == 1) {
            // 获取服务对象
            findTargetsApi().then((res) => {
              // console.log(res);
              // let arr = res.filter((item, idx) => item.code != 'all' && idx < 5);
              let arr = res.filter((item, idx) => idx < 4);
              this.workNaviData = arr;
              this.getFindService(1,arr[0].id);
              this.getFindTopBanner(1,'student');
            });
          }
        }
        if (item.code == 2) {
          if (item.status == 1) {
            // this.getFindFeatureColumnByList();
            this.getFindThemeByKeyword()
          }
        }
        if (item.code == 4) {
          if (item.status == 1) {
            this.getFindChannel(item.code);
          }
        }
        if (item.code == 5) {
          if (item.status == 1) {
            this.getFindNotice(item.code);
          }
        }
      });
    });

    // 获取地图列表
    findServiceMapApi().then(res => {
      console.log('地图',res);
      this.mapList = res || [];
    })

  },
  mounted() {
    new Swiper(".swiper-container", {
      //  direction: 'vertical', // 垂直切换选项
      //mousewheel: true, //滚轮
      autoplay: {
        //自动开始
        delay: 25000, //时间间隔
        disableOnInteraction: false, //*手动操作轮播图后不会暂停*
      },
      loop: true, // 循环模式选项

      // slidesPerView: 1,
      // spaceBetween: 40,
      // breakpointsInverse: true,
      breakpoints: {
        //当宽度大于等于320
        320: {
          slidesPerView: 2,
          spaceBetween: 10,
        },
        //当宽度大于等于480
        480: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
        //当宽度大于等于640
        640: {
          slidesPerView: 4,
          spaceBetween: 30,
        },
      },

      // 如果需要分页器
      pagination: {
        el: ".swiper-pagination",
        clickable: true, // 分页器可以点击
      },

      // 如果需要前进后退按钮
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },

      // 如果需要滚动条
      scrollbar: {
        el: ".swiper-scrollbar",
      },
    });
  },
  methods: {
    /**
    * hex:获取到的主题色，opacity:透明度
    */
    hexToRgba(hex, opacity) {
       return 'rgba(' + parseInt('0x' + hex.slice(1, 3)) + ',' + parseInt('0x' + hex.slice(3, 5)) + ',' + parseInt('0x' + hex.slice(5, 7)) + ',' + opacity + ')'
    },
    // 获取顶部办事栏
    getFindTopBanner(e,id) {
      // let str = `[${e}]`;
      this.commonIdx = e - 1;
      findTopBannerApi({ targets: id })
        .then((res) => {
          // console.log(res);
          this.commonList = res;
        })
        .catch((err) => {
          this.$message.error(err.message);
        });
    },
    // 查询首页-办事服务列表
    getFindService(e, id) {
      let dto = {
        page: 1,
        pageSize: 6,
        targets: id,
      };
      this.workIndex = e - 1;
      findServiceApi(dto)
        .then((res) => {
          // console.log(res);
          this.serviceTotal = res.serviceNumber;
          this.workData = res.voList.list;
        })
        .catch((err) => {
          this.$message.error(err.message);
        });
    },
    // 获取特色专栏
    getFindFeatureColumnByList() {
      findFeatureColumnByListApi({ page: 1, pageSize: 12 }).then((res) => {
        // console.log(res);
        // this.featureData = res.list;
        // if (res.list.length < 5) {
        if (res.list.length < 4) {
          this.featureData = [res.list];
        } else {
          // this.featureData = res.list.chunk(4);
          this.featureData = res.list.chunk(3);
        }
      });
    },
    // 获取专区列表
    getFindThemeByKeyword() {
      findUnionByKeywordApi({ page: 1, pageSize: 12 })
        .then((res) => {
          // console.log(res);
          let list = res?.pageListVo?.list || [];
          if (list.length < 4) {
          this.featureData = [list];
        } else {
          // this.featureData = list.chunk(4);
          this.featureData = list.chunk(3);
        }
        })
        .catch((err) => {
          this.$message.error(err.message);
        });
    },
    // 获取快捷通道
    getFindChannel(code) {
      findChannelApi(code).then((res) => {
        // console.log(res);
        this.shortcutData = res;
      });
    },
    // 获取通知公告
    getFindNotice() {
      findNoticeApi({ page: 1, pageSize: 3 }).then((res) => {
        // console.log(res);
        res.list.forEach((item) => {
          item.time = format(item.createTime, "yyyy-MM-dd");
        });
        this.noticeData = res.list || [];
      });
    },

    // 切换导航栏
    changeUrl(url, val) {      
      this.naviId = val.id;
      if (val.classify == 1) {//权责清单
        if(url == '/detailedList'){
          // this.ifShowDept = true;
        }else{
          this.$router.push(`${url}?naviId=${val.id}`);
        }
      } else {
        window.open(url);
      }
    },
    handleMouseOver(url, val) {      
      this.naviId = val.id;
      this.type = 'mask';
      if (val.classify == 1) {//权责清单
        if(url == '/detailedList'){
          this.ifShowDept = true;
        }
      }
    },
    modalFn(val,type){      
      if(val == 2){
        if(this.type != 'mask'){
          this.ifShowDept = false;
        }
      }else{
        this.ifShowDept = true;
      }
      this.type = type;
    },

    bannerClick() {
      // return
      if (this.bannerInfo.classify == 2) {
        this.$router.push(
          `${this.bannerInfo.link}?naviId=${this.bannerInfo.id}`
        );
      } else if (this.bannerInfo.classify == 3) {
        window.open(this.bannerInfo.link);
      }
    },
    onClick() {},
    onSearch(e) {
      // let val = e.target.value;
      // console.log(val,this.keyWord);
      // 阻止冒泡
      event.stopPropagation();
      if (this.keyWord) {
        this.naviArr.forEach((item) => {
          if (item.link == "/") {
            sessionStorage.setItem("searchKeyWord", this.keyWord);
            this.$router.push("/search?naviId=" + item.id);
          }
        });
      } else {
        this.$message.info("请输入关键字");
      }
    },
    loginFn() {
      // window.open("https://portal.ly-sky.com:7435/swzx/#/login");
      this.$router.push("/login");
    },
    logout() {
      let that = this;
      this.$confirm({
        title: "确认退出登录么？",
        okText: "确认",
        cancelText: "取消",
        onOk() {
          let headers = {
            // "userAuthType": "MS"
            "X-Requested-With": "XMLHttpRequest",
            gatewayAppId: "ly-portal-affairs",
            gatewayserviceid: "ly-portal-affairs-svc",
            Authorization: global.tokenId,
            Loginuserid: global.userId,
            Loginuserorgid: global.orgId,
          };
          logout("", headers)
            .then((e) => {
              // console.log('e', e);
            })
            .catch((res) => {
              // console.log(res);
              // sessionStorage.removeItem('ly-portal-affairs-ui-userLogin')
              sessionStorage.clear();
              that.$message.success("登出成功！");
              setTimeout(() => {
                that.$router.push("/login");
              }, 500);
              // window.location = window.casLogoutUrl;
            });
        },
      });
    },
    toSchool(){
      window.open('https://www.hbmzu.edu.cn/')
    },
    goToOrder(item) {
      if (item.classify == 1) {
        this.$router.push(item.content);
      } else if (item.classify == 2) {
        window.open(item.content);
      }
    },
    // 跳转主题详情
    gotoThemeDetails(e) {
      this.naviArr.forEach((item) => {
        if (item.link == "/theme") {
          this.$router.push(
            "/themeDetails?themeId=" + e.id + "&naviId=" + item.id
          );
        }
      });
    },
    // 跳转查看指南
    gotoWork(idx, e) {
      if (idx == 0) {
        window.open("https://portal.ly-sky.com:6208/#/login");
      } else if (idx == 1) {
        // console.log(e,'item-----------');
        // 请求点击增加热度接口
        let dto = {
        "serviceId": e.id,
        "userId": "",
       }
       let userId = sessionStorage.getItem('userId');
       if(userId){
        dto.userId = userId;
       }
        usageLogsApi(dto).then(res => {})
        this.naviArr.forEach((item) => {
          if (item.link == "/serviceHall") {
            this.$router.push(
              "/serviceDetails?serviceManageId=" + e.id + "&naviId=" + item.id
            );
          }
        });
      } else if (idx == 2) {
        window.open(e.pcUrl);
      }
    },
    topWork(val) {
      this.naviArr.forEach((item) => {
        if (item.link == "/serviceHall") {
          this.$router.push(
            "/serviceDetails?serviceManageId=" +
              val.serviceManageId +
              "&naviId=" +
              item.id
          );
        }
      });
    },
    // 快捷通道
    gotoShortcut(url) {
      window.open(url);
    },
    toNavi(code) {
      if(code == 1){ //办事服务
        this.naviArr.forEach((item) => {
          if (item.link == "/serviceHall") {
            this.$router.push("/serviceHall?naviId=" + item.id);
          }
        });
      }else if(code == 2){ //特色专栏
        this.naviArr.forEach((item) => {
          if (item.link == "/theme") {
            this.$router.push("/theme?naviId=" + item.id);
          }
        });
      }else if(code == 5){ //通知公告
        this.naviArr.forEach((item) => {
          if (item.link == "/") {
            this.$router.push("/notice?naviId=" + item.id);
          }
        });
      }else if(code == 6){ //服务地图
        window.open(this.findTopBar.serviceMapUrl)
      }
    },
    gotoNoticeDetails(val) {
      this.$router.push("/noticeDetails?noticeId=" + val.id);
    },
    handleHover(idx){
      this.mapIdx = idx;
    },
    toMap(link){
      window.open(link)
    }
  },
};
</script>

<style scoped lang="less">
.home {
  width: 100%;
  .curs {
    cursor: pointer;
  }
  .title {
    font-weight: 700;
    font-size: 32px;
    color: #0d1c28;
    text-align: left;
  }
  .background-img {
    background: url("../assets/icon/pic-schoolbg.png") no-repeat center;
    background-size: cover;
    text-align: left;
    // height: 492px;
    height: 640px;
    position: relative;
    .top {
      justify-content: space-between;
      padding-top: 24px;
      margin-bottom: 33px;
      .top_head {
        color: #fff;
        font-size: 14px;
        .top_head_box {
          color: #fff;
          padding: 0 32px;
          position: relative;
          cursor: pointer;
        }
        .pseudo_class::after {
          content: "";
          position: absolute;
          top: 20%;
          right: -3%;
          width: 1px;
          height: 14px;
          background: #fff;
          opacity: 0.5;
        }
      }
    }
    .navi {
      color: #fff;
      height: 138px;
      .logo_top{
        padding-top: 12px;
        margin-bottom: 27px;
        justify-content: space-between;
      }
      .navi_box {
        font-size: 16px;
        cursor: pointer;
        position: relative;
        margin-right: 24px;
        padding: 8px 12px;
      }
      .line_class {
        color: var(--themeColor);
        border-radius: 8px;
        opacity: 0.6;
        background: #FFF;
      }
      .login_class {
        background: rgba(255, 255, 255, 0.2);
        padding: 5px 12px;
        border-radius: 4px;
      }
      .top_r{
        font-size: 16px;
        .line_ver{
          margin: 0 32px;
          width: 1px;
          height: 14px;
          opacity: 0.5;
          background: #FFF;
        }
      }
    }
    .navi div:last-child {
      margin-right: 0;
    }
    .line {
      width: 100%;
      height: 1px;
      background: #fff;
      opacity: 0.2;
    }
    .ban_title {
      div {
        text-shadow: 0px 2px 4px rgba(0, 0, 0, 0.15);
      }
    }
    .ban_title div:first-child {
      font-size: 56px;
      // margin-top: 47px;
      // margin-top: 72px;
      margin-bottom: 7px;
      font-weight: 800;
    }
    .ban_title div:last-child {
      font-size: 24px;
    }
    .search_class {
      margin: 20px 0 0;
      padding: 0;
      color: #fff;
      width: 80%;
      .serach_box {
        display: flex;
        align-items: center;
        height: 60px;
        border-radius: 2px;
        background: #fff;
        font-size: 16px;
        .serach_ipt {
          color: #7a8ba4;
          padding: 18px 20px;
          flex: 3;
        }
        .serach_bon {
          background: var(--themeSloganColor);
          color: #fff;
          flex: 1;
          padding: 18px 0;
          text-align: center;
        }
      }
      .search_ul{
        color: var(--themeColor);
        .search_tag {
          border-radius: 4px;
          opacity: 0.7;
          background: #FFF;
          padding: 0 15px;
          margin-right: 12px;
          line-height: 28px;
          img {
            width: 16px;
            margin-left: 9px;
            cursor: pointer;
          }
        }
      }
    }
    .common_box {
      background: #fff;
      box-shadow: 0px 3px 20px rgba(9, 41, 77, 0.1);
      border-radius: 2px;
      padding: 20px 30px;
      // width: 424px;
      height: 260px;
      overflow-y: auto;
      width: 35.3%;
      max-width: 26.2rem;
      min-width: 15rem;
      .common_box_top {
        // border-bottom: 1px solid #e7e7e7;
        .common_box_title {
          font-size: 18px;
          line-height: 27px;
          font-weight: 600;
          margin-right: 38px;
          cursor: pointer;
        }
        .common_box_title_cls {
          color: var(--themeColor);
          border-bottom: 2px solid var(--themeColor);
        }
      }
      .common_ul {
        flex-wrap: wrap;
        justify-content: space-between;
        margin-top: 25px;
        .common_li {
          margin-bottom: 14px;
          width: 46%;
          // 超出10字省略
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          cursor: pointer;
          .common_yuan {
            width: 5px;
            height: 5px;
            background: #1f2c4b;
            border-radius: 50%;
            margin-right: 8px;
          }
        }
        .common_li:hover {
          color: var(--themeColor);
        }
      }
    }
    .tips {
      padding: 2px 12px;
      position: absolute;
      right: 1%;
      // top: 45%;
      top: 221px;
      width: 72px;
      background: #fff;
      border-radius: 4px;
      text-align: center;
      box-shadow: 5px 6px 38px rgba(9, 41, 77, 0.1);
      a {
        // padding: 15px 0;
        padding: 16px 0;
        display: block;
        border-bottom: 1px solid #e2eef8;
        &:last-child {
          border-bottom: none;
        }
        img {
          width: 24px;
        }
        div {
          font-size: 12px;
          color: #555555;
        }
      }
    }
  }

  // 特色专栏
  .feature {
    margin-top: 22px;
    margin-bottom: 56px;
    height: 21rem;
    .swiper_box {
      display: flex !important;
      .box_shadow {
        // width: 25%;
        width: 34%;
        padding: 1rem;
        cursor: pointer;
        .sip_hover {
          border-radius: 8px;
          height: 16.625rem;
          // height: 15.25rem;
          transition: all 0.3s ease;
          background: #fff;
          box-shadow: 0px 0px 18px rgba(122, 139, 164, 0.15);
        }
      }
      img {
        border-radius: 8px 8px 0 0;
        width: 100%;
        height: 8.75rem;
        object-fit: cover;
      }
      .swiper_con {
        padding: 24px;
        text-align: left;
        .swiper_tit {
          font-size: 20px;
          color: #0d1c28;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .swiper_clamp {
          -webkit-line-clamp: 2;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          overflow: hidden;
          text-overflow: ellipsis;
          color: #727475;
        }
      }
    }
    .sip_hover:hover {
      transition: all 0.3s ease;
      background: #1890ff !important;
      transform: translate3d(0, -0.3rem, 0);
      .swiper_tit,
      .swiper_clamp {
        color: #fff;
      }
    }
  }
  .feature_bg{
    background:rgb(247, 248, 251) url('../assets/index/zone_bgImg.png') no-repeat;
    background-color: rgb(247, 248, 251);
    background-size: cover;
    padding-top: 48px;
  }
  /deep/.ant-carousel .slick-dots li.slick-active button {
    background: var(--themeColor);
    height: 4px;
  }
  /deep/.ant-carousel .slick-dots li button {
    background: #ccc;
    width: 24px;
    height: 4px;
  }
  /deep/.ant-carousel .slick-dots-bottom {
    bottom: -15px;
  }

  .work_service_time {
    font-size: 14px;
    color: #7a8ba4;
    font-weight: 500;
    margin-left: 32px;
    span {
      color: var(--themeSloganColor);
    }
  }
  // 办事服务
  .work_service {
    margin-top: 14px;
    .work_navi {
      padding: 0 8.75rem;
      flex-wrap: nowrap;
      .work_box {
        font-size: 18px;
        color: #374567;
        cursor: pointer;
        background: var(--themeColor1);
        padding: 1.063rem 4.375rem;
        margin-left: 24px;
        min-width: 212px;
        &:first-child {
          margin-left: 0;
        }
      }
      .click_sty {
        color: #fff;
        background: var(--themeColor);
        position: relative;
      }
      .click_sty::after{
        content: '';
        position: absolute;
        left: 50%;
        bottom: -10px;
        transform: translateX(-50%);
        width: 0;
        height: 0;
        border-left: 10px solid transparent;
        border-right: 10px solid transparent;
        border-top: 10px solid var(--themeColor);
      }
    }
    .work_lattice {
      margin-top: 32px;
      justify-content: normal;
      flex-wrap: wrap;
      .lat_out {
        padding: 24px;
        border-radius: 8px;
        border: 1px solid #e0e5f0;
        width: 32%;
        margin-bottom: 20px;
        position: relative;
        transition: all 0.3s ease;
        overflow: hidden;
        margin-right: 0;
        align-items: normal;
        .lat-r {
          // margin-left: 24px;
          margin-left: 5%;
          text-align: left;
          color: #7a8ba4;
          overflow: hidden;
          width: 100%;
          .lat_tit {
            font-size: 18px;
            color: #374567;
            margin-bottom: 12px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            position: relative;
            .work_tag {
              border-radius: 9px;
              padding: 0 6px;
              font-size: 12px;
            }
            // .work_tag_bg1 {
            //   border: 1px solid #f5212d;
            //   color: #f5212d;
            // }
            .work_tag_bg1 {
              background: #f5212d;
              color: #fff;
              margin-left: 8px;
            }
            .work_tag_bg2 {
              background: #ff8C00;
              color: #fff;
              margin-left: 8px;
            }
            .work_tag_bg3 {
              border: 1px solid #00C800;
              color: #00C800;
              margin-left: 8px;
            }
          }
          .lat_con {
            font-size: 14px;
            // margin-bottom: 12%;
            margin-bottom: 24px;
            .text_top {
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
              position: relative;
            }
          }
          .lat_con div:first-child {
            margin-right: 16px;
          }
          .lat_con div:last-child {
            margin-left: 16px;
          }
          .lat_con_cls::after {
            content: "";
            position: absolute;
            width: 1px;
            height: 16px;
            top: 5%;
            right: 5%;
            background: #ebeffc;
          }
          .lat_bom {
            width: 100%;
            div {
              flex: 1;
            }
          }
          .lat_hot {
            // margin-right: 32px;
            // margin-right: 9%;
          }
          .pr_11 {
            padding-right: 5%;
            // padding-right: 10%;
          }
        }
        .hover_cls {
          display: none;
          vertical-align: middle;
        }
      }
      .lat_out:hover {
        transition: all 0.3s ease;
        .hover_cls {
          display: flex;
          justify-content: space-around;
          align-items: center;
          position: absolute;
          bottom: 0;
          left: 0;
          background: var(--themeColor6);
          box-shadow: inset 0px 1px 0px rgba(255, 255, 255, 0.4);
          backdrop-filter: blur(4px);
          padding: 2% 8%;
          width: 100%;
          .hover_box {
            font-size: 14px;
            color: #fff;
            position: relative;
          }
          .hover_box_fal::after {
            content: "";
            position: absolute;
            top: 14%;
            right: -1%;
            width: 1px;
            height: 16px;
            background: #fff;
          }
        }
      }
      .lat_out:not(:nth-child(3n)) {
        margin-right: calc(8% / 4);
      }
    }
  }

  // 查看更多按钮
  .check_more {
    color: #555;
    border: 1px solid #D5D8DA;
    border-radius: 4px;
    padding: 8px 17px;
    cursor: pointer;
    font-size: 14px;
    img{
      margin-left: 8px;
    }
  }

  // 服务统计
  .service_data {
    // margin-bottom: 64px;
    .service_data_bner {
      position: absolute;
      top: 568px;
      padding: 22px 0;
      background: rgba(91, 134, 170, 0.30);
      border: 1px solid #FFF;
      backdrop-filter: blur(10px);
      // width: 100%;
      // height: 190px;
      // background: url("../assets/index/server-banner.png") no-repeat center;
      .data_box {
        justify-content: space-around;
        .sev_data_box div:first-child {
          font-size: 32px;
          font-weight: 700;
          color: #fff;
          padding-bottom: 16px;
          position: relative;
        }
        .sev_data_box div:last-child {
          font-size: 16px;
          color: #333;
        }
        .sev_data_cls::after {
          content: "";
          position: absolute;
          bottom: 10%;
          left: 50%;
          transform: translate(-50%);
          width: 32px;
          height: 2px;
          background: var(--themeSloganColor);
        }
      }
    }
  }

  // 快捷通道
  .shortcut {
    margin-bottom: 64px;
    .shortcut_big {
      margin-top: 22px;
      display: flex;
      flex: 1;
      flex-wrap: wrap;
      text-align: left;
      border-left: 1px solid #e0e5f0;
      // border-top: 1px solid #e0e5f0;

      .shortcut_box {
        position: relative;
        width: 16.6%;
        display: block;
        padding: 28px 24px;
        border-right: 1px solid #e0e5f0;
        border-bottom: 1px solid #e0e5f0;
        cursor: pointer;
        transition: all 0.3 ease;
        box-sizing: border-box;
        // background: url("../assets/icon/banner-2.png") no-repeat right bottom;
        background: url('../assets/index/shortcut_bg.png') no-repeat;
        .name {
          color: #374567;
          font-weight: 500;
          font-size: 16px;
        }
        img {
          margin-bottom: 23px;
          width: 44px;
        }
        // .blue_line{
        //   display: none;
        // }
      }
      .shortcut_box:nth-child(1),
      .shortcut_box:nth-child(2),
      .shortcut_box:nth-child(3),
      .shortcut_box:nth-child(4),
      .shortcut_box:nth-child(5),
      .shortcut_box:nth-child(6) {
        border-top: 1px solid #e0e5f0;
      }
      .shortcut_box:hover {
        transition: all 0.3 ease;
        .blue_line {
          position: absolute;
          top: 0;
          left: 0;
          display: block;
          height: 4px;
          width: 100%;
          // background: #396ee5;
          background: #f90;
        }
        box-shadow: 0 10px 20px 0 #ecedf4;
      }
    }
  }

  // 超出省略
  .ellipsis {
    // -webkit-line-clamp: 3;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  // 通知公告
  .notice {
    // .notice_big {
    //   text-align: left;
    //   margin-top: 24px;
    //   .notice_box {
    //     padding: 24px;
    //     box-shadow: 0px 0px 24px rgba(122, 139, 164, 0.25);
    //     width: 32%;
    //     display: flex;
    //     flex-direction: column;
    //     height: 240px;
    //     cursor: pointer;
    //     position: relative;
    //     overflow: hidden;
    //     .notice_title {
    //       -webkit-line-clamp: 2;
    //       margin-bottom: 24px;
    //     }
    //     .con {
    //       color: #7a8ba4;
    //       margin-bottom: 28px;
    //       -webkit-line-clamp: 3;
    //     }
    //     .bom {
    //       // margin-right: 42px;
    //       color: #7a8ba4;
    //       position: relative;
    //       display: flex;
    //       align-items: center;
    //       img {
    //         margin-right: 9px;
    //       }
    //       .dept_css {
    //         display: block;
    //         overflow: hidden;
    //         // max-width: 166px;
    //         max-width: 10.375rem;
    //         white-space: nowrap;
    //         text-overflow: ellipsis;
    //       }
    //     }
    //     .bom_cls {
    //       position: absolute;
    //       bottom: 24px;
    //     }
    //   }
    // }

    .notice_ul{
      border-radius: 8px;
      border: 1px solid #E0E5F0;
      padding: 18px 24px;
      margin-top: 22px;
      .notice_li{
        padding-bottom: 18px;
        margin-bottom: 18px;
        border-bottom: 1px dashed #E7E7E7;
        display: flex;
        align-items: center;
        cursor: pointer;
        .notice_time{
          margin-right: 43px;
          color: var(--themeColor);
          font-size: 16px;
          .day_time{
            font-size: 24px;
            font-weight: 700;
          }
        }
      }
      .notice_li:last-child{
        padding-bottom: 0;
        margin-bottom: 0;
        border-bottom: none;
      }
    }
  }

  .dept_modal{
    position: absolute;
    top: 138px;
    width: 100%;
  }

  // 服务地图
  .map_box{
    border-radius: 8px;
    border: 1px solid #E7E7E7;
    box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.10);
    padding: 24px;
    margin-top: 22px;
    .map-img{
      height: 292px;
      max-width: 650px;
      width: 100%;
      img{
        width: 100%;
        height: 100%;
      }
    }
    .map_ul{
      margin-left: 34px;
      width: 100%;
      max-width: 466px;
      .map_li{
        text-align: left;
        cursor: pointer;
        .flex{
          margin-bottom: 16px;
        }
        img{
          margin-right: 6px;
        }
        .dept_name{
          font-size: 18px;
        }
        .map_info{
          margin-left: 26px;
          color: #7A8BA4;
          font-size: 14px;
        }
      }
      .map_li:first-child{
        margin-bottom: 46px;
        padding-bottom: 46px;
        border-bottom: 1px dashed #CECECE;
      }
      .map_{
        margin-bottom: 0 !important;
        padding-bottom: 0 !important;
        border-bottom: none !important;
      }
      .map_li:hover .dept_name{
          color: var(--themeColor);
      }

    }
  }
}
/deep/.ant-btn-primary {
  background-color: var(--themeColor);
  border-color: var(--themeColor);
}
/deep/.ant-input-group-wrapper {
  width: 100%;
}
/deep/.ant-btn-lg {
  height: 56px;
  padding: 0 55px;
}
/deep/.ant-input-lg {
  height: 56px;
}

/deep/.swiper-pagination-bullet {
  width: 24px;
  height: 4px;
  border-radius: 0;
}
/deep/.ant-input-group .ant-input {
  border: none;
  box-shadow: none;
}
</style>
